import { useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useHistory } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import React, {
    useContext,
    useEffect,
    useState,
    useCallback,
    useMemo
} from 'react';
import { AgencyAdminService } from "twia-capability-agencyadmin";
import styles from '../../pages/Administration/Administration.module.scss'
import metadata from './EditMailingAddress.metadata.json5';

function EditMailingAddress(props) {
    const [editAddress, updateEditAddressVM] = useState({});
    const [address, setAddress] = useState();
    // US26490 updateLocationAddress for submit function
    const {  tdiAddress, updateMailingAddress, userVM } = props;
    const history = useHistory();
    const { refreshData } = useDataRefresh();
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    // DE15342 adding validation for submit
    const { onValidate, isComponentValid } =
    useValidation('EditMailingAddress');
    const [showErrors, setShowErrors] = useState(false)

    useEffect(() => {

        const addressVM = viewModelService.create(
            {},
            'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.TDIAgencyLookupDTO'
        );

        addressVM.agencyAddresses = viewModelService.create(
            { country: 'US'},
            'pc',
            'org.twia.elevate.edge.capabilities.agent.dto.TDIAgencyAddressDTO'
        );
        // DE15291 - Prefilling the address fields
        if(userVM){
            _.set(addressVM, 'agencyAddresses', userVM.organization_EXT.primaryPersonContact.primaryAddress)
        }

        updateEditAddressVM(addressVM);
    }, []);

    const setAvailableAddressValue = useMemo(() => {
        const agencyAddress = tdiAddress?.map(key => ({
                    name: translator({
                        id: key.recordID,
                        defaultMessage: key.displayName,
                    }),
                    code: key.recordID
                }))

        return agencyAddress;
    }, [tdiAddress, translator]);


    const getUSStateList = useMemo(() => {
        if (editAddress !== undefined && editAddress.agencyAddresses !== undefined && editAddress.agencyAddresses.value !== undefined && editAddress.agencyAddresses.value.state !== undefined) {
            return editAddress.agencyAddresses.value.state.aspects.availableValues.map(code => ({ code: code.code, name: translator({ id: code.name }) }));
        }
    
        return [];
    }, [editAddress, translator]);

    const handleValueChange = useCallback(
        (value) => {
            tdiAddress.some((element) => {

                if (element.recordID === value) {
                    _.set(editAddress, 'agencyAddresses', element)
                    
                    
                }
            });
            updateEditAddressVM(editAddress);
        },
        [editAddress, tdiAddress]);

    const cancel = useCallback(() => {
        history.go('/administration');
    }, [history]); 

     
    // DE15378
    // eslint-disable-next-line react-hooks/exhaustive-deps, consistent-return
    const submit = useCallback(() => {
        if (!isComponentValid) {
            setShowErrors(true)

            return false
        }

        updateMailingAddress(editAddress);
    });

    
    const writeValue = useCallback(
        (value, path) => {
    
          _.set(editAddress, path, value)
          updateEditAddressVM(editAddress);
          refreshData();
        },
        [editAddress, refreshData]
      );

    
    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
            showErrors,
            showRequired: true,
        },

        agencyAddress: {
            availableValues: setAvailableAddressValue,
            value: address,
            onValueChange: (value) => {setAddress(value); handleValueChange(value)}      
           
        },
        state: {
            availableValues: getUSStateList,
            value: _.get(editAddress.value, 'agencyAddresses.value.state')
        },
    };


    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            
        },
        resolveCallbackMap: {
            handleValueChange: handleValueChange,
            clickCancel: cancel,
            clickSubmit: submit
            
        },
    };

    return (
        <ViewModelForm
                uiProps={metadata.pageContent}
                 model={editAddress}
                overrideProps={overrideProps}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValueChange={writeValue}
                onValidationChange={onValidate}
                />
        );
    }

EditMailingAddress.propTypes = {
    
};

EditMailingAddress.defaultProps = {

};

export default EditMailingAddress;
